import { ArquivarSolicitacao } from "./ArquivarSolicitacao";

export default ArquivarSolicitacao;